import { Parameter } from "@app/core/models/parameter.model";
import { ApiBind } from './common.model';


/**
 * 広告リクエストのパラメータを表すモデル
 *
 * @exports
 */
export class AdRequestParameter extends Parameter {
    @ApiBind({column: 'id'})
    id: number;

    @ApiBind({column: 'can_edit'})
    canEdit: boolean;
}
